<app-navbar />

<main id="main-content">
  <section class="page-hero">
    <div class="container">
      <app-breadcrumb [trail]="[{ label: 'Solutions' }]" />
      <span class="eyebrow">Solutions</span>
      <h1>Fresh death data for the teams that fight deceased identity fraud</h1>
      <p>
        Deceased identities show up across lending, banking, hiring, insurance, government and
        collections. VerifyDeceased gives each of these teams confirmed, nationwide death records,
        often within a week of a person passing.
      </p>
    </div>
  </section>

  <section class="section">
    <div class="container">
      <div class="grid-3">
        @for (solution of solutions; track solution.slug) {
          <a class="feature-card solution-link" [routerLink]="[routes.solutions.url, solution.slug]">
            <span class="icon-badge" [innerHTML]="iconFor(solution.icon)"></span>
            <h3>{{ solution.name }}</h3>
            <p>{{ solution.cardDescription }}</p>
            <span class="link-more">Explore this solution</span>
          </a>
        }
      </div>
    </div>
  </section>

  <section class="section section-alt">
    <div class="container">
      <div class="section-head">
        <span class="eyebrow">Why teams choose us</span>
        <h2 class="section-title">One data advantage, many use cases</h2>
        <p class="section-lead">
          Every solution is powered by the same fast, confirmed death data and delivered through
          batch upload or a real time API.
        </p>
      </div>
      <div class="grid-3">
        <div class="card">
          <h3>Confirmed within a week</h3>
          <p>New records are added weekly, often within seven days, so you act before fraud completes.</p>
        </div>
        <div class="card">
          <h3>Nationwide coverage</h3>
          <p>Confirmed deceased records across all 50 states and the District of Columbia.</p>
        </div>
        <div class="card">
          <h3>Batch or API</h3>
          <p>Upload a file for a one time scrub or integrate the API for real time verification.</p>
        </div>
      </div>
    </div>
  </section>

  <section class="section">
    <div class="container">
      <div class="cta-band">
        <h2>Not sure which fits your team?</h2>
        <p>Tell us about your use case and we will show you how the data works for you.</p>
        <div class="actions-row center">
          <a class="btn btn-primary btn-lg" [routerLink]="[routes.contact.url]">Talk to sales</a>
          <a class="btn btn-outline btn-lg" [routerLink]="[routes.howItWorks.url]">See how it works</a>
        </div>
      </div>
    </div>
  </section>
</main>

<app-footer />
